import * as React from 'react';
import Button from '@mui/material/Button';
import closeIcon from '../../../images/closeIcon.svg';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ModelWrapper } from './ModelStyled';
const  AlertDialog=({ show, Message,onClose  }) =>{
  const handleClose = () => {
    onClose();
  };

  return (
    <div>
      <ModelWrapper
        open={show}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title" className="customDialogTitle">
         Reject
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" className="customDialog">
          <div><img src={closeIcon} alt="img" /></div>
           <div>{Message}</div> 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
              <Button variant="outlined" className="rightButton" onClick={handleClose}>Cancel</Button>
               <Button variant="contained" className='confirmButton' onClick={handleClose}>Confirm</Button>
        </DialogActions>
      </ModelWrapper>
    </div>
  );
};

export default AlertDialog;